module.exports = __webpack_public_path__ + "static/media/KDAA2_2.4dcfab51.png";